var map = {
	"./DBS.png": "8bbd",
	"./MDAQ.png": "32c7",
	"./SCB.png": "5018",
	"./bri.png": "d5f9",
	"./coinph.png": "cb8a",
	"./deemoney.png": "e56f",
	"./kebhana.png": "3231",
	"./koreainvestment.png": "b98e",
	"./metrobank.png": "2d6c",
	"./moneygram.png": "c80b",
	"./moneymatch.png": "e3b7",
	"./nium.png": "640c",
	"./rapyd.png": "2f4b",
	"./remitly.png": "e5ce",
	"./ripple.png": "8a7d",
	"./shinhan.png": "5fc0",
	"./snmsung-pay.png": "0de5",
	"./thunes.png": "133e",
	"./tranglo.png": "74a5",
	"./vietcombank.png": "1141",
	"./wallex.png": "4255",
	"./welcomebank.png": "46e1",
	"./wyre.png": "98db",
	"./xendit.png": "f7fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8695";